import moment from "moment";
import { FormikProps } from "formik";
import { DummyToRememberPeopleToCast, FieldDescriptor, Utils } from "@crispico/foundation-react";
import { DatePickerFieldEditor, DatePickerFieldEditorProps } from "@crispico/foundation-react/entity_crud/fieldEditors/DatePickerFieldEditor";

type InvoiceDateAdditionalFDProps = DummyToRememberPeopleToCast & { isStartOfDay: boolean | undefined };

export class InvoiceDateFieldEditor extends DatePickerFieldEditor {
    constructor(props: DatePickerFieldEditorProps) {
        super(props);
        this.scriptableUiImpl = ScriptableUi.extendImpl(this.scriptableUiImpl, original => ({
            setFieldValue: (value: any) => {
                if (this.props.fieldDescriptor) {
                    const isStartOfDay = (this.props.fieldDescriptor.additionalFieldEditorProps as InvoiceDateAdditionalFDProps)?.isStartOfDay;
                    isStartOfDay ? original.setFieldValue(moment(value).startOf("day").toISOString()) : original.setFieldValue(moment(value).endOf("day").toISOString());
                }
            }
        }));
    }
}

export class InvoiceDateFieldDescriptor extends FieldDescriptor {
    renderFieldEditor(formikProps: FormikProps<any>, additionalFieldEditorProps?: DummyToRememberPeopleToCast) {
        return <InvoiceDateFieldEditor fieldDescriptor={this} formikProps={formikProps} format={Utils.dateFormat} />;
    }
}